import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'react-jss';
import { PerformanceMarkerProvider } from '@bingads-webui-campaign-react/performance-marker-provider';
import { withComponentErrorLogging } from '@bingads-webui-campaign-react/global-error-options';
import { withSiteMap, getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { StepWizard } from '@bingads-webui-campaign-react/step-wizard';
import { MmpFetchProvider } from '@bingads-webui-campaign-react/xandr-campaign';

import { XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS } from '../xandr-video-campaign-crud-scenarios';

const XandrVideoCampaignSettingsPageImpl = ((props) => {
  const routeToNavigateToWhenDone = getRoutePathById(props.siteMap, 'adgroups');

  return (
    <PerformanceMarkerProvider
      name={XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS.XANDR_VIDEO_CAMPAIGN_SETTINGS.scenarioName}
      instrumentation={props.instrumentation}
      immediateDone
    >
      <MmpFetchProvider>
        <StepWizard
          wizardScenario={XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS.XANDR_VIDEO_CAMPAIGN_SETTINGS}
          routeToNavigateToWhenDone={routeToNavigateToWhenDone}
          {...props}
          extraStepsData={{
            currentCampaign: props.currentCampaign,
          }}
        />
      </MmpFetchProvider>
    </PerformanceMarkerProvider>
  );
});

XandrVideoCampaignSettingsPageImpl.propTypes = {
  siteMap: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  permissions: PropTypes.shape({}).isRequired,
  theme: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    save: PropTypes.func.isRequired,
  }).isRequired,
  instrumentation: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  currentAdGroup: PropTypes.shape({}),
  currentCampaign: PropTypes.shape({}),
};

XandrVideoCampaignSettingsPageImpl.defaultProps = {
  currentAdGroup: null,
  currentCampaign: null,
};

export const XandrVideoCampaignSettingsPage = withSiteMap(withTheme(withComponentErrorLogging(
  XandrVideoCampaignSettingsPageImpl,
  XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS.XANDR_VIDEO_CAMPAIGN_SETTINGS.scenarioName
)));
